<template>
  <div>
    <top-operation-data-table
      disp-mode="nowrap"
      :headers="headers"
      :items="items"
      :sort-by="['carop_name', 'car_type', 'car_kind']"
      :sort-desc="[false, false, false]"
      class="fixedWidth"
      locale="ja-jp"
      must-sort
      ref="ref"
      :expanded.sync="expanded"
      item-key="car_id"
      show-expand
    >
      <template v-slot:[`item.carop_name`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="d-inline-block text-truncate"
              style="max-width: 720px"
            >
              {{ item.carop_name }}
            </span>
          </template>
          <span>{{ item.carop_name }}</span>
        </v-tooltip>
      </template>
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-toolbar dense color="white">
          <v-toolbar-title>管理車両一覧</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mx-2" color="primary" @click="downloadCSV()">
            ダウンロード
          </v-btn>
          <v-dialog v-model="dialog">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                color="primary"
                v-bind="attrs"
                v-on="on"
                v-if="!readOnly"
                @click="createItem()"
              >
                「新規登録」はこのボタンを押してください
              </v-btn>
            </template>
          </v-dialog>
        </v-toolbar>
        <v-container fluid>
          <error-message :error-object="errorObject" />
          <success-message :success-object="successObject" />
          <p style="margin: 5px 0 15px 0">
            管理車両情報は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
          </p>
          <p style="margin: 5px 0 25px 0" v-if="!readOnly">
            また表中の編集ボタンを押下して、当該車両の搭載資機材情報を新規登録・編集・削除することができます。
          </p>
          <p style="margin: 5px 0 25px 0" v-if="readOnly">
            また表中の参照ボタンを押下して、当該車両の搭載資機材情報を確認することができます。
          </p>
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="3">
              <v-autocomplete
                v-model="companyNameFilterValue"
                :items="[
                  {
                    carop_id: 'all',
                    carop_name: '全て'
                  },
                  { divider: true },
                  ...companiesSelect
                ]"
                label="車両事業者：営業所（文字入力で絞り込み可）"
                placeholder="選択してください"
                item-text="carop_name"
                item-value="carop_id"
                maxlength="30"
                outlined
                clearable
              >
                <template slot="item" slot-scope="data">
                  <!-- Divider and Header-->
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item" />
                  </template>
                  <!-- Normal item -->
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.carop_name" />
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="3">
              <v-select
                v-model="carOperatorClsFilterArray"
                :items="caropClses"
                label="車両事業者区分"
                placeholder="選択してください"
                item-text="text"
                item-value="text"
                outlined
                clearable
                multiple
              >
              </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="3">
              <v-text-field
                v-model="telNumberFilterValue"
                label="代表電話番号"
                placeholder="部分一致絞り込み"
                append-icon="mdi-magnify"
                maxlength="20"
                outlined
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="3">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="carNumberFilterValue"
                    label="車番"
                    placeholder="部分一致絞り込み"
                    append-icon="mdi-magnify"
                    maxlength="15"
                    outlined
                    clearable
                    v-on="on"
                  >
                  </v-text-field>
                </template>
                <p>
                  車両の種類に応じて、以下の形式で車番を入力してください。<br />
                  部分一致で絞り込まれます。
                </p>
                <table>
                  <tr>
                    <td>一般車両：</td>
                    <td style="padding-left: 1em;">鹿児島 200 あ 1234</td>
                  </tr>
                  <tr>
                    <td>自衛隊車両：</td>
                    <td style="padding-left: 1em;">12-3456</td>
                  </tr>
                  <tr>
                    <td>外交官車両：</td>
                    <td style="padding-left: 1em;">外-1234</td>
                  </tr>
                  <tr>
                    <td>領事館車両：</td>
                    <td style="padding-left: 1em;">領-1234</td>
                  </tr>
                </table>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="3">
              <v-text-field
                v-model="equipmentNameFilterValue"
                label="搭載資機材"
                placeholder="部分一致絞り込み"
                append-icon="mdi-magnify"
                outlined
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="3">
              <v-select
                v-model="carTypeFilterArray"
                :items="cartypes"
                label="種別"
                placeholder="選択してください"
                item-text="text"
                item-value="text"
                outlined
                clearable
                multiple
              >
              </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="2">
              <v-select
                v-model="carKindFilterArray"
                :items="carkinds"
                label="種類"
                placeholder="選択してください"
                item-text="text"
                item-value="text"
                outlined
                clearable
                multiple
              >
              </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="2">
              <v-select
                v-model="carSizeFilterArray"
                :items="carsizes"
                label="大きさ"
                placeholder="選択してください"
                item-text="text"
                item-value="text"
                outlined
                clearable
                multiple
              >
              </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="2">
              <v-select
                v-model="carStatusFilterArray"
                :items="carStatus"
                label="車両状態"
                placeholder="選択してください"
                item-text="text"
                item-value="text"
                outlined
                clearable
                multiple
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row> </v-row>
        </v-container>
        <v-data-footer
          :pagination="pagination"
          :options="options"
          :items-per-page-options="[5, 10, 15, -1]"
          @update:options="updateOptions"
          items-per-page-text="$vuetify.dataTable.itemsPerPageText"
        />
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <div style="padding: 10px;">
            <top-operation-data-table
              disp-mode="nowrap"
              :headers="equipmentHeaders"
              :items="item.equipments"
              :sort-by="['cls', 'kind', 'id']"
              :sort-desc="[false, false, false]"
              class="fixedWidth"
              locale="ja-jp"
              must-sort
              dense
              ref="equipRef"
            >
              <template v-slot:[`item.cls`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="d-inline-block text-truncate"
                      style="max-width: 720px"
                    >
                      {{ item.cls }}
                    </span>
                  </template>
                  <span>{{ item.cls }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.kind`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="d-inline-block text-truncate"
                      style="max-width: 720px"
                    >
                      {{ item.kind }}
                    </span>
                  </template>
                  <span>{{ item.kind }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="d-inline-block text-truncate"
                      style="max-width: 720px"
                    >
                      {{ item.name }}
                    </span>
                  </template>
                  <span>{{ item.name }}</span>
                </v-tooltip>
              </template>
            </top-operation-data-table>
          </div>
        </td>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div>
          <v-btn
            small
            class="mx-2 ma-2"
            color="primary"
            @click.stop="editItem(item)"
          >
            {{ $editButtonText(readOnly) }}
          </v-btn>
          <v-btn
            small
            class="mx-2 ma-2"
            color="primary"
            @click.stop="deleteConfirm(item)"
            v-if="!readOnly"
          >
            削除
          </v-btn>
        </div>
      </template>
    </top-operation-data-table>

    <v-dialog v-model="deleteDialog" persistent max-width="400">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          ><p>
            車番「{{ deleteNumber }}」の管理車両を削除してもよろしいですか？
          </p>
          <p>
            当該車両の搭載資機材情報も同時に削除されますので、ご注意ください。
          </p></v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="deleteItem(deleteCarIndex)"
            :disabled="processingFlag"
          >
            削除
          </v-btn>
          <v-btn
            color="primary"
            @click="deleteDialog = false"
            :disabled="processingFlag"
          >
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" opacity="1" color="white" z-index="2147483647">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import ScreenAuthority from "@/plugins/screen-authority";
import { ScreenId } from "@/js/value-objects/screen-id";
import messageUtils from "@/mixins/message-utils";
import { fileDownload } from "@/js/utils";

Vue.use(ScreenAuthority);

export default {
  mixins: [messageUtils],
  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    overlay: false,
    processingFlag: false,
    dialog: false,
    deleteDialog: false,
    deleteCarIndex: -1,
    deleteNumber: null,
    items: [],
    editedIndex: -1,
    editedItem: {
      car_id: null,
      carop_name: null,
      car_type: "",
      car_kind: "",
      car_size: "",
      car_limit: "",
      car_number: null
    },
    companyNameFilterValue: "",
    carOperatorClsFilterArray: "",
    carTypeFilterArray: "",
    carKindFilterArray: "",
    carSizeFilterArray: "",
    carNumberFilterValue: "",
    carStatusFilterArray: [],
    telNumberFilterValue: "",
    equipmentNameFilterValue: "",
    companies: [],
    equipmentList: [],
    readOnly: true,
    expanded: []
  }),

  computed: {
    carTypes() {
      return [
        { value: 8, text: "バス／乗合／大型" },
        { value: 9, text: "バス／乗合／中型" },
        { value: 10, text: "バス／乗合／小型" },
        { value: 11, text: "バス／貸切／大型" },
        { value: 12, text: "バス／高速／大型" },
        { value: 13, text: "バス／特定／大型" },
        { value: 14, text: "バス／マイクロバス／－" },
        { value: 15, text: "福祉車両（車椅子）／車椅子3台／－" },
        { value: 16, text: "福祉車両（車椅子）／車椅子2台／－" },
        { value: 17, text: "福祉車両（車椅子）／車椅子1台／－" },
        { value: 18, text: "福祉車両（車椅子）／その他／－" },
        { value: 19, text: "福祉車両（ストレッチャー）／スト1台／－" },
        { value: 20, text: "福祉車両（ストレッチャー）／兼用／－" },
        { value: 21, text: "バス／貸切／中型" },
        { value: 22, text: "バス／貸切／小型" },
        { value: 23, text: "バス／高速／中型" },
        { value: 24, text: "バス／高速／小型" },
        { value: 25, text: "バス／特定／中型" },
        { value: 26, text: "バス／特定／小型" },
        { value: 27, text: "バス／特殊車両／－" }
      ];
    },
    cartypes() {
      return [
        {
          value: 1,
          text: "バス"
        },
        {
          value: 2,
          text: "福祉車両（車椅子）"
        },
        {
          value: 3,
          text: "福祉車両（ストレッチャー）"
        }
      ];
    },
    carkinds() {
      return [
        {
          value: 1,
          text: "乗合"
        },
        {
          value: 2,
          text: "貸切"
        },
        {
          value: 3,
          text: "高速"
        },
        {
          value: 4,
          text: "特定"
        },
        {
          value: 5,
          text: "マイクロバス"
        },
        {
          value: 6,
          text: "特殊車両"
        },
        {
          value: 7,
          text: "車椅子3台"
        },
        {
          value: 8,
          text: "車椅子2台"
        },
        {
          value: 9,
          text: "車椅子1台"
        },
        {
          value: 10,
          text: "その他"
        },
        {
          value: 11,
          text: "スト1台"
        },
        {
          value: 12,
          text: "兼用"
        }
      ];
    },
    carsizes() {
      return [
        {
          value: 1,
          text: "大型"
        },
        {
          value: 2,
          text: "中型"
        },
        {
          value: 3,
          text: "小型"
        },
        {
          value: 4,
          text: "－"
        }
      ];
    },
    caropClses() {
      return [
        { value: "1", text: "バス協会" },
        { value: "2", text: "ハイヤー・タクシー協会" },
        { value: "3", text: "社会福祉協議会" },
        { value: "4", text: "その他" }
      ];
    },
    carStatus() {
      return [
        {
          value: "6",
          text: "配車待ち"
        },
        {
          value: "8",
          text: "配車中"
        },
        {
          value: "9",
          text: "避難中"
        },
        {
          value: "10",
          text: "避難完了"
        }
      ];
    },
    headers() {
      let headers = [
        {
          text: "車両事業者ID",
          value: "carop_id",
          filter: this.companyNameFilter
        },
        {
          text: "車両事業者：営業所",
          value: "carop_name"
        },
        {
          text: "車両事業者区分",
          value: "carop_cls",
          filter: this.carOperatorClsFilter
        },
        {
          text: "代表電話番号",
          value: "tel_no",
          filter: this.telNumberFilter
        },
        {
          text: "メールアドレス",
          value: "mail_address"
        },
        {
          text: "車両ID",
          value: "car_id"
        },
        {
          text: "種別",
          value: "car_type",
          filter: this.carTypeFilter
        },
        {
          text: "種類",
          value: "car_kind",
          filter: this.carKindFilter
        },
        {
          text: "大きさ",
          value: "car_size",
          filter: this.carSizeFilter
        },
        {
          text: "定員",
          value: "car_limit"
        },
        {
          text: "車番",
          value: "car_number",
          filter: this.carNumberFilter
        },
        {
          text: "車両状態",
          value: "car_status",
          filter: this.carStatusFilter
        },
        {
          text: "資機材IDリスト",
          align: " d-none",
          value: "equipments",
          filter: this.equipmentFilter
        },
        {
          text: "搭載資機材",
          align: "center",
          value: "data-table-expand",
          width: "70px"
        },
        {
          text: "操作",
          value: "actions",
          sortable: false,
          width: "171px"
        }
      ];
      return headers;
    },

    equipmentHeaders() {
      let equipmentHeader = [
        {
          text: "資材ID",
          align: " d-none",
          value: "id"
        },
        {
          text: "事業区分",
          value: "cls"
        },
        {
          text: "分類",
          value: "kind"
        },
        {
          text: "資機材名",
          value: "name"
        },
        {
          text: "個数",
          value: "quantity"
        }
      ];
      return equipmentHeader;
    },

    companiesSelect() {
      var companiesSelect = [];
      var prevCompanyName = "";
      this.companies.forEach(function(company) {
        if (prevCompanyName != company.company_name) {
          if (prevCompanyName) {
            companiesSelect.push({ divider: true });
          }
          companiesSelect.push({ header: company.company_name });
        }
        companiesSelect.push(company);
        prevCompanyName = company.company_name;
      });
      return companiesSelect;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    $route: "initialize"
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;
      const screen = this.$screenOperationAuthority(
        ScreenId.SF1701,
        ScreenId.SF1701
      );
      this.readOnly = screen.readOnly;
      this.screenId = screen.screenId;
      this.screenTitle = screen.screenTitle;
      this.handleSuccess(this.$route.params);

      // 管理車両一覧取得
      await this.$store.dispatch("car/loadCar", this.screenId).catch(error => {
        this.handleError(error, this.screenId, "aggregation-menu");
      });
      this.items = this.convertItems(this.$store.state.car.data.results);

      // 車両事業者一覧取得
      await this.$store
        .dispatch("carOperator/loadCarOperator", this.screenId)
        .catch(error => {
          this.handleError(error, this.screenId, "aggregation-menu");
        });
      this.companies = this.$store.state.carOperator.data.results;
      this.companies.sort(function(a, b) {
        if (a.carop_name > b.carop_name) {
          return 1;
        } else {
          return -1;
        }
      });
      this.companies.forEach(function(company) {
        var companyArray = company.carop_name.split("：");
        var company_name = companyArray[0];
        var sales_office_name = companyArray[1];
        company.company_name = company_name;
        company.sales_office_name = sales_office_name;
      });

      // 資機材一覧取得
      await this.$store
        .dispatch("equipment/loadEquipment", this.screenId)
        .catch(error => {
          this.handleError(error, this.screenId, "aggregation-menu");
        });
      this.equipmentList = this.$store.state.equipment.data.results;

      var equipmentList = this.equipmentList;
      this.items.forEach(function(car) {
        car.equipments.forEach(function(montEquipment) {
          montEquipment.name = "";
          equipmentList.forEach(function(equipment) {
            if (montEquipment.id === equipment.equipment_id) {
              montEquipment.cls = equipment.equipment_cls;
              montEquipment.kind = equipment.equipment_kind;
              montEquipment.name = equipment.equipment_name;
              return;
            }
          });
        });
        car.equipments = car.equipments.filter(
          montEquipment => montEquipment.name
        );
      });

      this.overlay = false;
    },

    createItem() {
      this.$router.push(`/car/register/web`);
    },

    editItem(item) {
      this.$router.push(`/car/register/web/${item.car_id}`);
    },

    async deleteItem(index) {
      this.clearMessage();
      this.processingFlag = true;
      // 管理車両削除API呼出
      await this.$store
        .dispatch("car/deleteCar", {
          screenId: this.screenId,
          car: this.items[index]
        })
        .then(() => {
          var successObject = this.$store.state.car.successObject;
          if (successObject.status == 200) {
            this.items.splice(index, 1);
          }
        })
        .catch(error => {
          this.handleUpdateError(error);
          window.scrollTo(0, 0);
        })
        .finally(() => {
          this.processingFlag = false;
          this.deleteDialog = false;
          this.deleteCarIndex = -1;
        });
    },

    deleteConfirm(item) {
      this.deleteDialog = true;
      this.deleteNumber = item.car_number;
      this.deleteCarIndex = this.items.indexOf(item);
    },

    companyNameFilter(value) {
      if (this.companyNameFilterValue === "all") {
        return true;
      }
      if (!this.companyNameFilterValue) {
        return true;
      }
      return value === this.companyNameFilterValue;
    },

    carNumberFilter(value) {
      if (!this.carNumberFilterValue) {
        return true;
      }
      return value.includes(this.carNumberFilterValue);
    },

    telNumberFilter(value) {
      if (this.telNumberFilterValue === "all") {
        return true;
      }
      if (!this.telNumberFilterValue) {
        return true;
      }
      return value.includes(this.telNumberFilterValue);
    },

    carOperatorClsFilter(value) {
      if (!this.carOperatorClsFilterArray.length) {
        return true;
      }
      return this.carOperatorClsFilterArray.includes(value);
    },
    carTypeFilter(value) {
      if (!this.carTypeFilterArray.length) {
        return true;
      }
      return this.carTypeFilterArray.includes(value);
    },
    carKindFilter(value) {
      if (!this.carKindFilterArray.length) {
        return true;
      }
      return this.carKindFilterArray.includes(value);
    },
    carSizeFilter(value) {
      if (!this.carSizeFilterArray.length) {
        return true;
      }
      return this.carSizeFilterArray.includes(value);
    },
    carStatusFilter(value) {
      if (!this.carStatusFilterArray.length) {
        return true;
      }
      return this.carStatusFilterArray.includes(value);
    },
    equipmentFilter(value) {
      if (!this.equipmentNameFilterValue) {
        return true;
      }
      for (var key in value) {
        var equipment = value[key];
        if (equipment.name.includes(this.equipmentNameFilterValue)) {
          return true;
        }
      }
      return false;
    },

    convertItems(sourceItems) {
      var items = [];

      // 車両種別（種別、種類、大きさ）、車両事業者区分、車両状態を変換する
      var convertText = function(target, sourceList) {
        var filtered = sourceList.filter(function(source) {
          return target == source.value;
        });
        if (filtered.length !== 1) {
          return "";
        }
        return filtered[0].text;
      };

      var carTypes = this.carTypes;
      var caropClses = this.caropClses;
      var carStatus = this.carStatus;

      sourceItems.forEach(function(item) {
        var carTypeText = convertText(item.car_type, carTypes);
        if (carTypeText) {
          var carTypeTextArray = carTypeText.split("／");
          item.car_type = carTypeTextArray[0];
          item.car_kind = carTypeTextArray[1];
          item.car_size = carTypeTextArray[2];
        }
        item.carop_cls = convertText(item.carop_cls, caropClses);
        item.car_status = convertText(item.car_status, carStatus);
        item.tel_no = item.tel_no ? item.tel_no : "";
        item.mail_address = item.mail_address ? item.mail_address : "";

        items.push(item);
      });
      return items;
    },
    /**
     * CSVダウンロード処理
     */
    downloadCSV() {
      let csv = "\ufeff";

      /* タイムスタンプ算出 */
      let now = new Date();
      let year = now.getFullYear();
      let month = ("00" + (now.getMonth() + 1)).slice(-2);
      let day = ("00" + now.getDate()).slice(-2);
      let hour = ("00" + now.getHours()).slice(-2);
      let minute = ("00" + now.getMinutes()).slice(-2);
      let timeStamp = year + month + day + "_" + hour + minute;

      /* ヘッダー */
      const headers = {
        carop_id: "車両事業者ID",
        carop_name: "車両事業者：営業所",
        carop_cls: "車両事業者区分",
        tel_no: "代表電話番号",
        mail_address: "メールアドレス",
        car_id: "車両ID",
        car_type: "種別",
        car_kind: "種類",
        car_size: "大きさ",
        car_limit: "定員",
        car_number: "車番",
        car_status: "車両状態",
        equipment_cls: "事業区分",
        equipment_kind: "分類名",
        equipment_name: "資機材名",
        equipment_quantity: "個数"
      };
      const headerList = [];
      Object.keys(headers).forEach(key => {
        headerList.push(headers[key]);
      });
      csv += headerList.join(",") + "\n";

      /* Body（本文） */
      let sorted = JSON.parse(JSON.stringify(this.items));
      sorted = this.$refs.ref.$children[0].$children[0].sortItems(sorted);
      sorted.forEach(item => {
        const itemList = [];
        Object.keys(headers).forEach(header => {
          if (item[header] !== undefined) {
            itemList.push(item[header]);
          }
        });
        if (itemList.length > 0) {
          if (item.equipments && item.equipments.length > 0) {
            //            let sortedEquipments = JSON.parse(JSON.stringify(item.equipments));
            //            sortedEquipments = self.$refs.equipRef.$children[0].$children[0].sortItems(sortedEquipments);
            item.equipments.forEach(equip => {
              csv += itemList.join(",");
              csv += "," + equip.cls;
              csv += "," + equip.kind;
              csv += "," + equip.name;
              csv += "," + equip.quantity;
              csv += "\n";
            });
          } else {
            for (var i = 0; i < 4; i++) {
              itemList.push("");
            }
            csv += itemList.join(",") + "\n";
          }
        }
      });
      let blob = new Blob([csv], { type: "text/csv" });
      fileDownload(blob, "管理車両一覧_" + timeStamp + ".csv");
    }
  }
};
</script>
